export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SITE = {
  name: "Brickn-Ridge Construction",
  tagline: "BUILT TO LAST. CRAFTED TO SPEC.",
  phone: "+1 812-830-2316",
  phoneDisplay: "(812) 830-2316",
  phoneHref: "tel:+18128302316",
  email: "Tlay91@gmail.com",
  emailHref: "mailto:Tlay91@gmail.com",
  area: "45-mile radius of Lawrenceville, IL",
  hub: "Lawrenceville, IL",
  hours: "Mon–Sat 9:00am–5:00pm",
  hoursNote: "Sundays closed — emergency calls only",
};

export const SERVICES = [
  {
    id: "hvac",
    title: "HVAC Systems",
    description:
      "Complete heating, ventilation, and air conditioning installs, seasonal maintenance, ductwork optimization, and emergency furnace or AC repair.",
    image:
      "https://images.unsplash.com/photo-1620653713380-7a34b773fef8?crop=entropy&cs=srgb&fm=jpg&q=85",
    features: [
      "AC & Heating Unit Installation",
      "Duct Repair & Air Quality",
      "Seasonal System Tune-ups",
      "24/7 Emergency Repairs",
    ],
    testid: "service-card-hvac",
  },
  {
    id: "plumbing",
    title: "Precision Plumbing",
    description:
      "Full-service plumbing repair, pipe replacement, water heater installation, clog removal, and leak detection for residential & commercial builds.",
    image:
      "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&q=85",
    features: [
      "Water Heater Replacement",
      "Fixture & Pipe Upgrades",
      "Drain & Sewer Clears",
      "Emergency Leak Repair",
    ],
    testid: "service-card-plumbing",
  },
  {
    id: "carpentry",
    title: "Custom Carpentry",
    description:
      "Structural framing, custom cabinetry, deck construction, trim work, staircases, and timber structural builds with precision craftsmanship.",
    image:
      "https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&q=85",
    features: [
      "Framing & Structural Timber",
      "Custom Decks & Patios",
      "Cabinetry & Built-ins",
      "Finish Trim & Moldings",
    ],
    testid: "service-card-carpentry",
  },
  {
    id: "handyman",
    title: "General Handyman & Repair",
    description:
      "All-in-one property maintenance, drywall patching, door and window installs, tile touchups, hardware upgrades, and complete handyman solutions.",
    image:
      "https://images.unsplash.com/photo-1676311396794-f14881e9daaa?crop=entropy&cs=srgb&fm=jpg&q=85",
    features: [
      "Drywall Repair & Painting Prep",
      "Door & Window Hardware",
      "Fixture & Appliance Mounting",
      "General Structural Repairs",
    ],
    testid: "service-card-handyman",
  },
];

export const GALLERY = [
  {
    title: "Structural Steel & Concrete Foundation",
    category: "General Construction",
    location: "Lawrenceville, IL",
    image:
      "https://images.unsplash.com/photo-1623489254637-a2dd8375243d?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 md:row-span-2",
    testid: "gallery-item-1",
  },
  {
    title: "Custom Staircase & Interior Timber Framing",
    category: "Carpentry",
    location: "Vincennes Region",
    image:
      "https://images.unsplash.com/photo-1656733911006-fcad49fa0d52?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:row-span-2",
    testid: "gallery-item-2",
  },
  {
    title: "Full House Framing & Architectural Woodwork",
    category: "Framing",
    location: "Olney, IL",
    image:
      "https://images.unsplash.com/photo-1768321917661-d4f1a89d2185?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "",
    testid: "gallery-item-3",
  },
  {
    title: "Commercial Pipe Network & Plumbing Overhaul",
    category: "Plumbing",
    location: "Bridgeport, IL",
    image:
      "https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "",
    testid: "gallery-item-4",
  },
  {
    title: "Modern Interior Beam & Room Renovation",
    category: "General Contracting",
    location: "Mt. Carmel, IL",
    image:
      "https://images.unsplash.com/photo-1715760374522-a609a0c2f65e?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-2 lg:col-span-4",
    testid: "gallery-item-5",
  },
];

export const CITIES = [
  "Lawrenceville",
  "Vincennes",
  "Bridgeport",
  "Sumner",
  "Olney",
  "Mt. Carmel",
  "Robinson",
  "Flat Rock",
];

export const SERVICE_OPTIONS = [
  "HVAC",
  "Plumbing",
  "Carpentry",
  "General Handyman",
  "Emergency Service",
  "Other Construction",
];

export const scrollToSection = (selector) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(selector, { offset: -70 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
};
